import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('beranda');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [settings, setSettings] = useState({
    navbar_title: 'BIMBEL STEMA KUPANG',
    navbar_logo: null,
    website_title: 'Bimbel Stema Kupang'
  });

  // Fetch settings dari API
  useEffect(() => {
    fetch('https://app.bimbelstemakupang.com/api/settings')
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setSettings({
            navbar_title: data.navbar_title || 'BIMBEL STEMA KUPANG',
            navbar_logo: data.navbar_logo,
            website_title: data.website_title || 'Bimbel Stema Kupang'
          });
          
          // Update document title
          if (data.website_title) {
            document.title = data.website_title;
          }
        }
      })
      .catch((error) => {
        console.error('Error fetching settings:', error);
      });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setActiveSection(href.replace('#', ''));
    setIsMobileMenuOpen(false); // Close mobile menu when clicking
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {/* Custom CSS untuk hamburger menu */}
      <style jsx>{`
        .mobile-menu-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 1040;
          opacity: ${isMobileMenuOpen ? '1' : '0'};
          visibility: ${isMobileMenuOpen ? 'visible' : 'hidden'};
          transition: all 0.3s ease;
        }

        .mobile-menu {
          position: fixed;
          top: 0;
          right: 0;
          width: 300px;
          height: 100vh;
          background: white;
          z-index: 1050;
          transform: translateX(${isMobileMenuOpen ? '0' : '100%'});
          transition: transform 0.3s ease;
          overflow-y: auto;
          box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
        }

        .mobile-menu-header {
          padding: 20px;
          border-bottom: 1px solid #e5e7eb;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .mobile-menu-close {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #6b7280;
          padding: 5px;
          border-radius: 50%;
          transition: all 0.2s ease;
        }

        .mobile-menu-close:hover {
          background: #f3f4f6;
          color: #1f2937;
        }

        .mobile-nav-links {
          padding: 20px 0;
        }

        .mobile-nav-link {
          display: block;
          padding: 15px 25px;
          color: #374151;
          text-decoration: none;
          font-weight: 500;
          transition: all 0.2s ease;
          border-left: 3px solid transparent;
        }

        .mobile-nav-link:hover {
          background: #f9fafb;
          color: #1e40af;
          border-left-color: #1e40af;
        }

        .mobile-nav-link.active {
          background: #eff6ff;
          color: #1e40af;
          border-left-color: #1e40af;
        }

        .hamburger {
          display: none;
          flex-direction: column;
          cursor: pointer;
          padding: 5px;
          border: none;
          background: none;
        }

        .hamburger span {
          width: 25px;
          height: 3px;
          background: ${isScrolled ? '#374151' : 'white'};
          margin: 3px 0;
          transition: 0.3s;
          transform-origin: center;
        }

        .hamburger.open span:nth-child(1) {
          transform: rotate(45deg) translate(6px, 6px);
        }

        .hamburger.open span:nth-child(2) {
          opacity: 0;
        }

        .hamburger.open span:nth-child(3) {
          transform: rotate(-45deg) translate(6px, -6px);
        }

        @media (max-width: 991px) {
          .hamburger {
            display: flex;
          }
          .desktop-menu {
            display: none;
          }
        }

        @media (min-width: 992px) {
          .mobile-menu-overlay,
          .mobile-menu {
            display: none;
          }
        }
      `}</style>

      <nav 
        className={`navbar navbar-expand-lg fixed-top transition-all ${
          isScrolled 
            ? 'navbar-light bg-white shadow-lg' 
            : 'navbar-dark bg-primary'
        }`}
        style={{
          transition: 'all 0.3s ease',
          backdropFilter: isScrolled ? 'blur(10px)' : 'none',
          zIndex: 1030
        }}
      >
        <div className="container">
          {/* Brand Logo */}
          <a 
            className="navbar-brand fw-bold d-flex align-items-center" 
            href="#beranda"
            onClick={() => handleNavClick('#beranda')}
            style={{
              color: isScrolled ? '#1e40af' : 'white',
              textDecoration: 'none',
              transition: 'color 0.3s ease'
            }}
          >
            <div 
              className="me-2 d-flex align-items-center justify-content-center rounded"
              style={{
                width: '60px',
                height: '60px',
                backgroundColor: isScrolled ? '#1e40af' : 'white',
                color: isScrolled ? 'white' : '#1e40af',
                transition: 'all 0.3s ease'
              }}
            >
              {/* Logo dari API atau default */}
              {settings.navbar_logo ? (
                <img 
                  src={`https://app.bimbelstemakupang.com/storage/${settings.navbar_logo}`} 
                  alt="Navbar Logo" 
                  style={{
                    width: '60px',
                    height: '60px',
                    objectFit: 'contain'
                  }}
                  onError={(e) => {
                    // Fallback jika gambar tidak bisa dimuat
                    e.target.style.display = 'none';
                    e.target.parentNode.innerHTML = '<strong>S</strong>';
                  }}
                />
              ) : (
                <img 
                  src="/assets/img/misc/LOGO.png" 
                  alt="Default Logo" 
                  style={{
                    width: '60px',
                    height: '60px',
                    objectFit: 'contain'
                  }}
                  onError={(e) => {
                    // Fallback jika default logo tidak ada
                    e.target.style.display = 'none';
                    e.target.parentNode.innerHTML = '<strong>S</strong>';
                  }}
                />
              )}
            </div>
            {settings.navbar_title}
          </a>

          {/* Hamburger Menu Button - Mobile Only */}
          <button 
            className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Desktop Navigation Menu */}
          <div className="desktop-menu d-none d-lg-flex">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
              <li className="nav-item">
                <a 
                  className={`nav-link fw-medium px-3 py-2 rounded transition-all ${
                    activeSection === 'beranda' ? 'active' : ''
                  }`}
                  href="#hero"
                  onClick={() => handleNavClick('#hero')}
                  style={{
                    color: isScrolled ? '#374151' : 'white',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = isScrolled ? '#eff6ff' : 'rgba(255,255,255,0.1)';
                    e.target.style.color = isScrolled ? '#1e40af' : '#f0f9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = isScrolled ? '#374151' : 'white';
                  }}
                >
                  Beranda
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className={`nav-link fw-medium px-3 py-2 rounded transition-all ${
                    activeSection === 'about' ? 'active' : ''
                  }`}
                  href="#about"
                  onClick={() => handleNavClick('#about')}
                  style={{
                    color: isScrolled ? '#374151' : 'white',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = isScrolled ? '#eff6ff' : 'rgba(255,255,255,0.1)';
                    e.target.style.color = isScrolled ? '#1e40af' : '#f0f9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = isScrolled ? '#374151' : 'white';
                  }}
                >
                  About
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className={`nav-link fw-medium px-3 py-2 rounded transition-all ${
                    activeSection === 'tahapan-belajar' ? 'active' : ''
                  }`}
                  href="#work-process"
                  onClick={() => handleNavClick('#work-process')}
                  style={{
                    color: isScrolled ? '#374151' : 'white',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = isScrolled ? '#eff6ff' : 'rgba(255,255,255,0.1)';
                    e.target.style.color = isScrolled ? '#1e40af' : '#f0f9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = isScrolled ? '#374151' : 'white';
                  }}
                >
                  Tahapan Belajar
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className={`nav-link fw-medium px-3 py-2 rounded transition-all ${
                    activeSection === 'tentang-bimbel' ? 'active' : ''
                  }`}
                  href="#why-choose-us"
                  onClick={() => handleNavClick('#why-choose-us')}
                  style={{
                    color: isScrolled ? '#374151' : 'white',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = isScrolled ? '#eff6ff' : 'rgba(255,255,255,0.1)';
                    e.target.style.color = isScrolled ? '#1e40af' : '#f0f9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = isScrolled ? '#374151' : 'white';
                  }}
                >
                  Tentang Bimbel
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className={`nav-link fw-medium px-3 py-2 rounded transition-all ${
                    activeSection === 'jenis-sekdin' ? 'active' : ''
                  }`}
                  href="#team"
                  onClick={() => handleNavClick('#team')}
                  style={{
                    color: isScrolled ? '#374151' : 'white',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = isScrolled ? '#eff6ff' : 'rgba(255,255,255,0.1)';
                    e.target.style.color = isScrolled ? '#1e40af' : '#f0f9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = isScrolled ? '#374151' : 'white';
                  }}
                >
                  Jenis Sekdin
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className={`nav-link fw-medium px-3 py-2 rounded transition-all ${
                    activeSection === 'paket' ? 'active' : ''
                  }`}
                  href="#pricing"
                  onClick={() => handleNavClick('#pricing')}
                  style={{
                    color: isScrolled ? '#374151' : 'white',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = isScrolled ? '#eff6ff' : 'rgba(255,255,255,0.1)';
                    e.target.style.color = isScrolled ? '#1e40af' : '#f0f9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = isScrolled ? '#374151' : 'white';
                  }}
                >
                  Paket
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className={`nav-link fw-medium px-3 py-2 rounded transition-all ${
                    activeSection === 'kontak' ? 'active' : ''
                  }`}
                  href="#contact"
                  onClick={() => handleNavClick('#contact')}
                  style={{
                    color: isScrolled ? '#374151' : 'white',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = isScrolled ? '#eff6ff' : 'rgba(255,255,255,0.1)';
                    e.target.style.color = isScrolled ? '#1e40af' : '#f0f9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = isScrolled ? '#374151' : 'white';
                  }}
                >
                  Kontak
                </a>
              </li>

              {/* CTA Button */}
              <li className="nav-item">
                <a 
                  className="btn ms-3 fw-bold px-4 py-2 rounded-pill"
                  href="https://app.bimbelstemakupang.com"
                  style={{
                    backgroundColor: isScrolled ? '#1e40af' : 'white',
                    color: isScrolled ? 'white' : '#1e40af',
                    border: 'none',
                    transition: 'all 0.3s ease',
                    transform: 'scale(1)',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  Masuk
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div 
        className="mobile-menu-overlay"
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

      {/* Mobile Menu */}
      <div className="mobile-menu">
        <div className="mobile-menu-header">
          <div className="d-flex align-items-center">
            <div 
              className="me-2 d-flex align-items-center justify-content-center rounded"
              style={{
                width: '40px',
                height: '40px',
                backgroundColor: '#1e40af',
                color: 'white'
              }}
            >
              {settings.navbar_logo ? (
                <img 
                  src={`https://app.bimbelstemakupang.com/storage/${settings.navbar_logo}`} 
                  alt="Logo" 
                  style={{
                    width: '40px',
                    height: '40px',
                    objectFit: 'contain'
                  }}
                />
              ) : (
                <strong>S</strong>
              )}
            </div>
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#1e40af' }}>
              STEMA KUPANG
            </span>
          </div>
          <button 
            className="mobile-menu-close"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>
        
        <div className="mobile-nav-links">
          <a 
            href="#beranda" 
            className={`mobile-nav-link ${activeSection === 'beranda' ? 'active' : ''}`}
            onClick={() => handleNavClick('#beranda')}
          >
            🏠 Beranda
          </a>
          <a 
            href="#about" 
            className={`mobile-nav-link ${activeSection === 'about' ? 'active' : ''}`}
            onClick={() => handleNavClick('#about')}
          >
            📖 About
          </a>
          <a 
            href="#tahapan-belajar" 
            className={`mobile-nav-link ${activeSection === 'tahapan-belajar' ? 'active' : ''}`}
            onClick={() => handleNavClick('#tahapan-belajar')}
          >
            📚 Tahapan Belajar
          </a>
          <a 
            href="#tentang-bimbel" 
            className={`mobile-nav-link ${activeSection === 'tentang-bimbel' ? 'active' : ''}`}
            onClick={() => handleNavClick('#tentang-bimbel')}
          >
            🎓 Tentang Bimbel
          </a>
          <a 
            href="#jenis-sekdin" 
            className={`mobile-nav-link ${activeSection === 'jenis-sekdin' ? 'active' : ''}`}
            onClick={() => handleNavClick('#jenis-sekdin')}
          >
            🏛️ Jenis Sekdin
          </a>
          <a 
            href="#paket" 
            className={`mobile-nav-link ${activeSection === 'paket' ? 'active' : ''}`}
            onClick={() => handleNavClick('#paket')}
          >
            💼 Paket
          </a>
          <a 
            href="#kontak" 
            className={`mobile-nav-link ${activeSection === 'kontak' ? 'active' : ''}`}
            onClick={() => handleNavClick('#kontak')}
          >
            📞 Kontak
          </a>
          
          {/* Mobile CTA Button */}
          <div style={{ padding: '20px 25px', borderTop: '1px solid #e5e7eb', marginTop: '10px' }}>
            <a 
              href="https://app.bimbelstemakupang.com/login"
              style={{
                display: 'block',
                textAlign: 'center',
                backgroundColor: '#1e40af',
                color: 'white',
                padding: '12px 20px',
                borderRadius: '25px',
                textDecoration: 'none',
                fontWeight: '600',
                transition: 'all 0.3s ease'
              }}
              onTouchStart={(e) => {
                e.target.style.backgroundColor = '#1e3a8a';
              }}
              onTouchEnd={(e) => {
                e.target.style.backgroundColor = '#1e40af';
              }}
            >
              🚀 Masuk
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;